
import Loading from "../loading/Loading";

export default function Button({
	onClick,
	label,
	isLoading = false,
	color = "#ff694b",
	textColor = "#ffffff",
	className = "h-full min-h-[inherit] rounded-[10px]",
	labelClassName = "font-Vazir-600 font-semibold text-[14px]",
}) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={[
				"w-full flex flex-row items-center justify-center cursor-pointer border-0",
				className,
			].join(" ")}
			style={{ color: textColor, backgroundColor: color }}
		>
			{isLoading ? (
				<Loading color={textColor} width={20} />
			) : (
				<span className={labelClassName}>{label}</span>
			)}
		</button>
	);
}
